import React from "react";
import "../Styles/customer.css";
import { Link } from "react-router-dom";
import { Modal, Typography, Button, Box } from "@mui/material";
import Caution from "../asset/svg/caution";
import { toast } from "react-toastify";

const ReLoginModal = () => {
  return (
    <div>
      {toast.error("Session expired.")}
      <Modal open={true}>

        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'white',
            boxShadow: 24,
            p: 4,
            minWidth: 400,
            borderRadius: 2,
          }}
        >
          <div style={{
            textAlign: 'center',
            marginBottom: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <Caution />
          </div>
          <Typography variant="h6" component="h2" gutterBottom sx={{ textAlign: 'center' }}>
            Session has expired

          </Typography>
          <Typography variant="body1" sx={{ textAlign: 'center', marginBottom: '16px' }}>
            Please login again to continue.
          </Typography>
          <Link to="/">
            <Button variant="contained" fullWidth color="primary">
              Login
            </Button>
          </Link>
        </Box>
      </Modal>
    </div>


  );
};

export default ReLoginModal;

{/* <div className="modal">
        <div className="catModal">
          <div className="line"></div>
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Caution />
            <h1 className="text-lg font-black">Session expired</h1>
            <p className="text-sm">Please login again</p>
            <Link to="/">
              <button className="reLBtn">Login</button>
            </Link>
          </div>
        </div>
      </div> */}